<template>
    <div>
        <el-form :model="form" ref="form" label-width="120px" style="width: 600px;" :rules="rules">
            <el-form-item label="头像" prop="avatar">
                <Uploader v-model="form.avatar" />
            </el-form-item>
            <el-form-item label="昵称" prop="nickname">
                <el-input v-model="form.nickname" placeholder="请输入昵称" />
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入手机号" maxlength="11" />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input v-model="form.email" placeholder="请输入邮箱" />
            </el-form-item>
            <el-form-item label="登录密码" prop="loginPassword">
                <el-input v-model="form.loginPassword" placeholder="请输入登录密码" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSubmit">确认新增马甲号</el-button>
                <el-button @click="handleCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Uploader from '@/components/Uploader';
import { add } from '@/api/user/list';
export default {
    components: {
        Uploader
    },
    data() {
        return {
            form: {
                avatar: '',
                nickname: '',
                phone: '',
                email: '',
                loginPassword: ''
            },
            rules: {
                avatar: [{ required: true, message: '请上传头像' }],
                nickname: [{ required: true, message: '请输入昵称' }],
                phone: [{ required: true, message: '请输入手机号' },
                { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                email: [{ required: true, message: '请输入邮箱' },
                {
                    pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/, message:
                        '请输入正确的邮箱地址', trigger: 'blur'
                }
                ],
                loginPassword: [{ required: true, message: '请输入登录密码' }]
            }
        }
    },
    methods: {
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    mjFlag: 1,
                }
                add(params).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('新增马甲号成功！');
                        this.$router.back();
                    } else {
                        this.$message.error(message);
                    }
                })
            });
        },
        handleCancel() {
            this.$router.back();
        }
    }
}
</script>

<style></style>